<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="flex flex-col">
  @if (!readonly) {
    <div class="flex flex-col m-3">
      <form [formGroup]="commentForm" #formDirective="ngForm" (ngSubmit)="saveComment(formDirective)">
        <div class="flex items-start">
          <div class="w-full relative">
            <quill-editor
              class="w-full"
              [formControlName]="'body'"
              [modules]="quillModules"
              [mentionConfig]="mentionConfig"
            ></quill-editor>
          </div>
        </div>
        <div class="flex items-center mt-1 ml-auto justify-end">
          <button
            class="send-button"
            mat-flat-button
            [disabled]="commentForm.pristine || commentForm.invalid || isPosting"
            type="submit"
            [color]="'primary'"
          >
            <span>Post Comment</span>
          </button>
        </div>
      </form>
    </div>
  }

  <div class="max-h-120 overflow-y-auto">
    <div class="flex flex-col m-3">
      @for (comment of comments; track comment.id) {
        <ng-container
          [ngTemplateOutlet]="commentTemplate"
          [ngTemplateOutletContext]="{ comment: comment }"
        ></ng-container>
      }
    </div>
  </div>
</div>

<ng-template #commentTemplate let-comment="comment">
  <div class="flex mt-2 w-full comment-container">
    @if (!comment.editing) {
      <div class="flex flex-col w-full">
        <div class="flex flex-row items-end mb-2">
          <img class="w-8 h-8 rounded-full mr-3" src="{{ comment.user.avatar_url }}" />
          <b>{{ comment.user.full_name }}</b>
          @if (comment.commentable_type && comment.commentable_type != 'Project') {
            <div class="text-secondary ml-1">• {{ comment.commentable_name }}</div>
          }
        </div>
        <quill-view-html
          [content]="mentionsService.formatMessage(comment?.body) | linkify | domPurify"
          theme="snow"
          sanitize
          class="w-full border border-gray-200"
        ></quill-view-html>
        @if (!comment.replying) {
          <div class="flex items-center text-sm text-secondary mt-2 comment-controls">
            <p (click)="replyToComment(comment)">Reply</p>
            @if (user && user.id == comment.user.id) {
              <span class="mx-1"> • </span>
              <p (click)="editComment(comment)">Edit</p>
              <span class="mx-1"> • </span>
              <p (click)="deleteComment(comment)">Delete</p>
            }
            <p class="ml-auto">{{ comment.created_at | date: 'MMM dd, y' }}</p>
          </div>
        }
        @if (comment.replying) {
          <form [formGroup]="replyCommentForm">
            <div class="flex items-center text-sm text-secondary mt-2 w-full flex-col">
              <div class="flex w-full">
                <div class="w-full relative">
                  <quill-editor
                    class="w-full"
                    [formControlName]="'body'"
                    [modules]="quillModules"
                    [mentionConfig]="mentionConfig"
                  ></quill-editor>
                </div>
              </div>
              <div class="flex items-center mt-1 ml-auto justify-end">
                <button class="cancel-button mr-1" mat-flat-button (click)="cancelCommentReply(comment)">
                  <span>Cancel</span>
                </button>
                <button
                  class="send-button"
                  mat-flat-button
                  type="submit"
                  [color]="'primary'"
                  [disabled]="replyCommentForm.pristine || replyCommentForm.invalid"
                  (click)="saveCommentReply()"
                >
                  <span>Save</span>
                </button>
              </div>
            </div>
          </form>
        }
      </div>
    }

    @if (comment.editing) {
      <div class="flex flex-col mt-2px w-full">
        <form [formGroup]="editCommentForm" #editformDirective="ngForm" (ngSubmit)="updateComment(editformDirective)">
          <div class="flex items-start">
            <div class="w-full relative">
              <quill-editor
                class="w-full"
                [formControlName]="'body'"
                [modules]="quillModules"
                [mentionConfig]="mentionConfig"
              ></quill-editor>
            </div>
          </div>
          <div class="flex items-center mt-1 ml-auto justify-end">
            <button class="cancel-button mr-1" mat-flat-button (click)="cancelEditComment(comment)">
              <span>Cancel</span>
            </button>
            <button
              class="send-button"
              mat-flat-button
              [disabled]="editCommentForm.pristine || editCommentForm.invalid"
              type="submit"
              [color]="'primary'"
            >
              <span>Save</span>
            </button>
          </div>
        </form>
      </div>
    }
  </div>
  @for (childComment of comment.children; track childComment.id) {
    <div class="flex ml-6 flex-col">
      <ng-container
        [ngTemplateOutlet]="commentTemplate"
        [ngTemplateOutletContext]="{ comment: childComment }"
      ></ng-container>
    </div>
  }
</ng-template>
